import client from "@/utils/request";

export default {
  getDisChild(params = {}) {
    return client.request({
      url: '/api/v2/admin/get_display_page_childs',
      method: 'get',
      params: params
    })
  },

  getAllPromotion(param = {}) {
    return client.post('/api/v1/dashboardType', param);
  },

  addPromotion(param = {}) {
    return client.post('/api/v2/admin/add_promotion', param);
  },

  editPromotion(param = {}) {
    return client.post('/api/v2/admin/edit_promotion', param);
  },

  getPromotions(params = {}) {
    return client.request({
      url: '/api/v2/admin/get_promotions',
      method: 'get',
      params: params
    })
  },
  getTopList(params = {}) {
    return client.request({
      url: '/api/v2/admin/get_top_promotions',
      method: 'get',
      params: params
    })
  },
  // Mark 获取营销计划详情
  orederDetail(params = {}) {
    return client.request({
      url: '/api/v2/admin/get_top_promotion_products',
      method: 'get',
      params: params
    })
  },
  // Mark 获取营销计划列表
  selectPromotionDetail(param = {}) {
    return client.request({
      url: '/api/v2/admin/get_promotion',
      method: 'get',
      params: param
    })
  },
  // Mark 删除计划
  dropPromotion(param = {}) {
    return client.post('/api/v2/admin/delete_promotion', param);
  },
  // Mark 更新营销计划
  updatePromotionPriority(param = {}) {
    return client.post('/api/v2/admin/update_promotion_priority', param);
  },
  // Mark 开启/关闭计划
  changePromotionStatus(param = {}) {
    return client.post('/api/v2/admin/change_promotion_status', param);
  },
  // Mark 获取营销计划汇总数据
  getAllCount(param = {}) {
    return client.request({
      url: '/api/v2/admin/get_promotion_statistic',
      method: 'get',
      params: param
    })
  },
  getPreview(param = {}) {
    return client.post('/api/v1/getPreview', param);
  },
  // Mark 创建类型2的计划时判断是否已经开启应用
  isPostPurchaseAppInUse() {
    return client.request({
      url: '/api/v2/admin/is_post_purchase_app_in_use',
      method: 'get'
    })
  },
  //用于top Promotion的翻页
  queryPaging(param = {}) {
    return client.post('/api/v1/queryPaging', param);
  },
  // Mark 用于查询订单列表
  orderList(param = {}) {
    return client.request({
      url: '/api/v2/admin/get_promotion_orders',
      method: 'get',
      params: param
    })
  },
  // Mark 用于查询计划中的排除变体
  selectExcludeVariant(param = {}) {
    return client.request({
      url: '/api/v2/admin/get_products_variants',
      method: 'get',
      params: param
    })
  },
  // Mark 获取营销计划汇总数据
  getAllCount(param = {}) {
    return client.request({
      url: '/api/v2/admin/get_promotion_statistic',
      method: 'get',
      params: param
    })
  },
  //用于搜索计划中的排除变体
  searchVariant(param = {}) {
    return client.post('/api/v1/searchVariant', param);
  },
  //用于搜索最新一条计划的id
  selectPromotionId(param = {}) {
    return client.post('/api/v1/selectPromotionId', param);
  },
  //用于搜索本店价格最低的一个产品
  selectLowestPriceProduct(param = {}) {
    return client.post('/api/v1/selectLowestPriceProduct', param);
  },
  //获取编辑计划预览数据
  getPreviewData(param = {}) {
    return client.post('/api/v1/getTemplateProduct', param);
  },
}